






import CoHtml from '../co-html/CoHtml.vue';

const htmlTagPattern = /<\/?(?:a|b|br|code|em|h[1-6]|i|li|ol|p|pre|s|span|strong|ul)(?:\s[^>]*)?>/i;
const newlinePattern = /\r\n|\r|\n/;
const newlineGlobalPattern = /\r\n|\r|\n/g;

export default {
    name: 'CoEditorContent',
    components: {
        CoHtml,
    },
    props: {
        content: {
            type: String,
            default: '',
        },
    },
    computed: {
        normalizedContent() {
            if (!this.content) return '';
            if (!newlinePattern.test(this.content)) return this.content;
            if (htmlTagPattern.test(this.content)) return this.content;

            // Render legacy plain-text content safely while preserving user-entered line breaks.
            return this.content
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(newlineGlobalPattern, '<br>');
        },
    },
};
